$(function() {
    let notifications = $(".module-banner__notification");
    notifications.each(function() {
        if (!$("body").hasClass("website-state-edit")) {
            let btn = $("button", this);
            let textContent = $(".module-banner-text-container", this);
            textContent.hide();
            btn.on("click", function() {
                btn.toggleClass("notification-expanded");
                let isAriaExp = $(this).attr("aria-expanded");
                let newAriaExp = isAriaExp == "false" ? "true" : "false";
                $(this).attr("aria-expanded", newAriaExp);

                let isAriaHid = textContent.attr("aria-hidden");

                if (isAriaHid == "true") {
                    textContent.attr("aria-hidden", "false");
                    textContent.slideDown("fast", function() {});
                } else {
                    textContent.attr("aria-hidden", "true");
                    textContent.slideUp("fast");
                }
            });
        }
    });
});
